<template>
  <!-- Kontener główny dla strony 404 -->
  <div class="content-container">
    <!-- Pasek menu nawigacyjnego -->
    <TopMenu />
  </div>
  <!-- Komunikat o braku strony -->
  {{ t('page-not-found') }}
</template>

<script>
// Importujemy pasek menu, aby był widoczny nawet na stronie 404
import TopMenu from "../components/TopMenu.vue";

export default {
  name: "NotFoundView",
  components: {
    TopMenu,
  },
};
</script>
